export const environment = {
  production: true,
  apiUrl: 'https://gw1.shop/'
};
